import React, { useState } from 'react';
import cardIcon from '../../../images/cardIcon.png';
import viewImg from '../../../images/view.png';
import dealerCodeImg from '../../../images/code-image.png';
import creditLimitImg from '../../../images/creditlimit-img.png';
import cashImage from '../../../images/cash-img.png';
import riskImage from '../../../images/risk-image.png';
import './index.css';
import closeImg from './../../../images/modalclose.png';
import sapExcelIcon from './../../../images/sapExcel.png';
import { PreviewAppModal } from '../../../Pages/Registeration';
import {
  Form,
  FormGroup,
  Row,
  Col,
  Container,
  Label,
  Modal,
  ModalBody,
} from 'reactstrap';
import {
  assignDealerCode,
  updateCreditLimit,
  cashCreditRatio,
  riskMeasureTag,
} from '../../../constants/apiCalls';
import CommonButton from '../CommonButton/CommonButton';
import ModalService from '../../../services/ModalService';
import { useLocation } from 'react-router-dom';
import UserInput from '../UserInput/UserInput';
import SingleSelect from '../SingleSelect/SingleSelect';
import NumberFormatInput from '../NumberFormatInput/NumberFormatInput';
import { handleErrorMessage } from '../../../utils/utils';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import DateService from '../../../services/DateService';
import Switch from "react-switch";

const DealerCodeCard = ({
  onClick,
  show,
  cardClassName,
  elem,
  getDealerListData,
  handleChangeUserSwitch,
  handleSAPExcel
}) => {
  //  preview modal
  const [modal, setModal] = useState(false);
  const [userId, setUserId] = useState('');
  //Dealer Code Modal
  const [showDealerCodeModal, setShowDealerCodeModal] = useState(false);
  const [dealerCode, setdealerCode] = useState('');
  const [dealerCodeId, setdealerCodeId] = useState('');
  // cash ratio modal func
  const [businessInCash, setBusinessInCash] = useState('');
  const [businessInCredit, setBusinessInCredit] = useState('');
  const [cashCreditId, setCashCreditID] = useState('');
  const [CashCreditRatio, setCashCreditRatio] = useState('');
  // credit limit Modal
  const [showCreditLimitModal, setShowCreditLimitModal] = useState(false);
  const [creditLimit, setCreditLimit] = useState('');
  const [proposedCreditLimit, setProposedCreditLimit] = useState('');
  const [creditLimitID, setCreditLimitID] = useState('');
  // risk Measure Tag Modal
  const [showRiskMeasureTagModal, setShowRiskMeasureTagModal] = useState(false);
  const [showCashCreditRatioModal, setShowCashCreditRatioModal] = useState(
    false
  );
  const [showRiskMeasureTag, setShowRiskMeasureTag] = useState('');
  const [proposedRIskMeasureTag, setProposedRIskMeasureTag] = useState('');
  const [riskMeasureTagID, setRiskMeasureTagID] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const location = useLocation();

  // preview modal func
  const handlePreviewModal = (val) => {
    setUserId(val);
    setModal(!modal);
  };
  let num = CashCreditRatio && CashCreditRatio.includes('/') ? CashCreditRatio.split('/') : '';
  const options = [
    { id: 1, name: 'A' },
    { id: 2, name: 'B' },
    { id: 3, name: 'C' },
    { id: 4, name: 'D' },
    { id: 5, name: 'E' },
  ];

  const handleDealerCodeChange = (e) => {
    let val = e.target.value;
    setdealerCode(val);
  };

  // Assign Dealer Code Modal func
  const handleDealerCode = (e) => {
    setdealerCodeId(e);
    setShowDealerCodeModal(!showDealerCodeModal);
  };
  const handleCodeSubmit = (e) => {
    e.preventDefault();
    let payload = {
      dealer_id: dealerCodeId,
      dealer_code: dealerCode,
    };
    setIsloading(true);
    assignDealerCode((res) => {
      const { success, message, error } = res;
      if (success === true) {
        ModalService.openAlert('', message, 'success');
        getDealerListData();
        setIsloading(false);
        setdealerCode();
      } else if(success === false || success === 'undefined') {
        if (error.length > 0) {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setdealerCode();
      }
      setIsloading(false);
    }, payload);
    setShowDealerCodeModal(!showDealerCodeModal);
  };

  // change Handlers

  const handleCreditLimitChange = (e) => {
    let val = e.target.value;
    setCreditLimit(val);
  };

  const handleRiskMeasureTagChange = (e) => {
    let val = e.target.value;
    setShowRiskMeasureTag(val);
  };

  const handleCreditRatioChange = (e) => {
    let value = e.target.value;
    if (value < 0) value = 0;
    setBusinessInCash(value);
    if (value > 100) value = 100;
    setBusinessInCredit(100 - value);
    setBusinessInCash(value);
  };

  // credit limit func
  const handleCreditLimit = (e) => {
    setProposedCreditLimit(e.credit_limit);
    setCreditLimitID(e.id);
    setShowCreditLimitModal(!showCreditLimitModal);
  };
  const handleCreditLimitSubmit = (e) => {
    e.preventDefault();
    let payload = {
      dealer_id: creditLimitID,
      credit_limit: creditLimit,
      remark: 'Credit Limit Updated By Admin',
    };
    setIsloading(true);
    updateCreditLimit((res) => {
      const { success, message, error } = res;
      if (success === true) {
        setIsloading(false);
        ModalService.openAlert('', message, 'success');
        getDealerListData();
        setCreditLimit();
        setCreditLimitID();
      } else if(success === false || success === 'undefined') {
        if (error.length > 0) {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setCreditLimit();
        setCreditLimitID();
      }
      setIsloading(false);
    }, payload);
    setShowCreditLimitModal(!showCreditLimitModal);
  };

  // RIsk measure Tag limit func
  const handleRiskMeasureTag = (e) => {
    setProposedRIskMeasureTag(e.risk_measure_tag);
    setRiskMeasureTagID(e.id);
    setShowRiskMeasureTagModal(!showRiskMeasureTagModal);
  };
  const handleRiskMeasureTagSubmit = (e) => {
    e.preventDefault();
    let payload = {
      dealer_id: riskMeasureTagID,
      risk_measure_tag: showRiskMeasureTag,
    };
    setIsloading(true);
    riskMeasureTag((res) => {
      const { success, message, error } = res;
      if (success === true) {
        setIsloading(false);
        ModalService.openAlert('', message, 'success');
        getDealerListData();
        setShowRiskMeasureTag();
        setRiskMeasureTagID();
      } else if(success === false || success === 'undefined') {
        if (error.length > 0) {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setShowRiskMeasureTag();
        setRiskMeasureTagID();
      }
    }, payload);
    setIsloading(false);
    setShowRiskMeasureTagModal(!showRiskMeasureTagModal);
  };

  // credit ratio func
  const handleCashCreditRatio = (e) => {
    setCashCreditID(e.id);
    setCashCreditRatio(e.cash_credit_ratio);
    setShowCashCreditRatioModal(!showCashCreditRatioModal);
  };

  const handleCashCreditRatioSubmit = (evt) => {
    evt.preventDefault();
    let payload = {
      dealer_id: cashCreditId,
      expected_business_cash: businessInCash,
      expected_business_credit: businessInCredit,
    };
    setIsloading(true);
    cashCreditRatio((res) => {
      const { success, message, error } = res;
      if (success === true) {
        setIsloading(false);
        ModalService.openAlert('', message, 'success');
        getDealerListData();
        setCashCreditID();
        setBusinessInCash();
        setBusinessInCredit();
      } else if(success === false || success === 'undefined') {
        if (error.length > 0) {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setCashCreditID();
        setBusinessInCash();
        setBusinessInCredit();
      }
      setIsloading(false);
    }, payload);
    setShowCashCreditRatioModal(!showCashCreditRatioModal);
  };

  return (
    <>
      <div id='adminDealerCodeCard'>
        <div className='userData'>
          <Row>
            <Col lg={4} className='mb-lg-0 mb-4'>
              <div className='userData'>
                <div>
                  <div className='labelMargin'>
                    Dealership Name : {''}
                    <span className={cardClassName ? cardClassName : ''}>
                      {elem.business_name || 'N/A'}
                    </span>
                  </div>
                  <div className='labelMargin'>
                    Owner Name : {''}
                    <span className={cardClassName ? cardClassName : ''}>
                      {elem.primary_contact_name || 'N/A'}
                    </span>
                  </div>
                  {location &&
                    location.pathname === '/admin/assign-dealer-code' ? (
                    <div className='labelMargin'>
                      Form Number : {''}
                      <span className={cardClassName ? cardClassName : ''}>
                        {elem.id || 'N/A'}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {location &&
                    location.pathname === '/admin/manage-dealer' ? (
                    <div className='labelMargin'>
                      Dealer Code : {''}
                      <span className={cardClassName ? cardClassName : ''}>
                        {elem.dealer_code || 'N/A'}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className='labelMargin'>
                    Mobile No. : {''}
                    <span className={cardClassName ? cardClassName : ''}>
                      {elem.primary_contact_mobile || 'N/A'}
                    </span>
                  </div>
                </div>

                {show ? (
                  <div className='mt-4'>
                    <div className='labelMargin'>
                      City/Town : {''}
                      <span className={cardClassName ? cardClassName : ''}>
                        {elem.city || 'N/A'}
                      </span>
                    </div>
                    <div className='labelMargin'>
                      State : {''}
                      <span className={cardClassName ? cardClassName : ''}>
                        {elem.state || 'N/A'}
                      </span>
                    </div>
                    {location &&
                      location.pathname === '/admin/assign-dealer-code' ? (
                      <div className='labelMargin'>
                        Proposed Credit Limit by National Head : {''}
                        <span
                          className={cardClassName ? cardClassName : ''}
                        >
                          {elem.credit_limit || 'N/A'}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                    {location &&
                      location.pathname === '/admin/manage-dealer' ? (
                      <div className='labelMargin'>
                        Credit Limit : {''}
                        <span
                          className={cardClassName ? cardClassName : ''}
                        >
                          {elem.credit_limit || 'N/A'}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className='labelMargin'>
                      National Head : {''}
                      <span className={cardClassName ? cardClassName : ''}>
                        {elem.nh || 'N/A'}
                      </span>
                    </div>
                    <div className='labelMargin'>
                      State Head : {''}
                      <span className={cardClassName ? cardClassName : ''}>
                        {elem.sh || 'N/A'}
                      </span>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </Col>
            <Col lg={4} className='mb-lg-0 mb-4'>
              <div className='userData'>
                <div className='labelMargin'>
                  Territory : {''}
                  <span className={cardClassName ? cardClassName : ''}>
                    {elem.territory || 'N/A'}
                  </span>
                </div>
                <div className='labelMargin'>
                  Territory Manager : {''}
                  <span className={cardClassName ? cardClassName : ''}>
                    {elem.th && (elem.th.trim() !== "") ? elem.th : 'N/A'}
                  </span>
                </div>
                <div className='labelMargin'>
                  Date of Approval : {''}
                  <span className={cardClassName ? cardClassName : ''}>
                    {DateService.localDateOnly(elem.approval_date) || 'N/A'}
                  </span>
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div className='userData'>
                {location &&
                  location.pathname === '/admin/assign-dealer-code' ? (
                  <div
                    onClick={() => handleDealerCode(elem.id)}
                    className='modalLabel'
                  >
                    <img src={dealerCodeImg} alt='' />
                    <span className={cardClassName ? cardClassName : ''}>
                      Set Dealer Code
                    </span>
                  </div>
                ) : (
                  ''
                )}
                <div
                  onClick={() => handleCreditLimit(elem)}
                  className='modalLabel'
                >
                  <img src={creditLimitImg} alt='' />
                  <span className={cardClassName ? cardClassName : ''}>
                    Set Credit Limit
                  </span>
                </div>
                <div
                  onClick={() => handleRiskMeasureTag(elem)}
                  className='modalLabel'
                >
                  <img src={riskImage} alt='' />
                  <span className={cardClassName ? cardClassName : ''}>
                    Set Risk Measure Tag
                  </span>
                </div>
                <div
                  onClick={() => handleCashCreditRatio(elem)}
                  className='modalLabel mb-0'
                >
                  <img src={cashImage} alt='' />
                  <span className={cardClassName ? cardClassName : ''}>
                    Set Cash Credit Ratio
                  </span>
                </div>
                <div></div>
              </div>
            </Col>
          </Row>
        </div>
        <div className='d-flex flex-column justify-content-between'>
          <div className='text-right'>
            <img src={viewImg} alt="cardIcon" width={20} height={20} className="cardIcon editIcon" onClick={() => handlePreviewModal(elem.id)} />
            <img src={cardIcon} alt="cardIcon" width={20} height={20} className="cardIcon" onClick={onClick} />
          </div>
          {location && location.pathname === '/admin/manage-dealer' ?
            <div className='mt-1 d-flex'>
              <div className='mr-1'>{elem.is_active ? 'Active' : 'Inactive'}</div>
              <Switch
                uncheckedIcon={false}
                checkedIcon={false}
                height={20}
                width={50}
                handleDiameter={15}
                onColor="#545CD8"
                className="statusSwitch"
                id="statusSwitch"
                checked={elem.is_active}
                onChange={handleChangeUserSwitch}
              />
            </div>
            : ''}

          {location && location.pathname === '/admin/assign-dealer-code' ?
            <div className='mt-1 d-flex align-items-center'>
              <img src={sapExcelIcon} alt="cardIcon" width={30} height={30} className="cardIcon cursorPointer" onClick={() => handleSAPExcel(elem.id)} />
              <div className={cardClassName ? `${cardClassName} ml-1 cursorPointer` : ''} onClick={() => handleSAPExcel(elem.id)}>Download SAP excel</div>
            </div>
            : ''}

        </div>
      </div>

      {/* Dealer Code Modal */}
      <Modal
        isOpen={showDealerCodeModal}
        toggle={() => setShowDealerCodeModal(!showDealerCodeModal)}
        centered
        className='dealerCodeModal'
        id='dealerCodeModal'
      >
        <ModalBody className='p-0'>
          <div className='ModalArea'>
            <Container>
              <Row>
                <Col xs={12}>
                  <div className='modalHeading'>
                    <div className='title'>SET DEALER CODE</div>
                    <div className='closeButton'>
                      <img
                        src={closeImg}
                        alt='close'
                        onClick={() =>
                          setShowDealerCodeModal(!showDealerCodeModal)
                        }
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12}>
                  <Form onSubmit={handleCodeSubmit}>
                    <FormGroup className='d-flex flex-wrap align-items-center justify-content-center mb-0'>
                      <Label className='mr-2'>
                        Assign Dealer Code<span className='required'>*</span>
                      </Label>
                      <UserInput
                        required={true}
                        type='text'
                        name='dealerCode'
                        id='dealerCode'
                        placeholder='Type Here'
                        onChange={(e) => handleDealerCodeChange(e)}
                        value={dealerCode}
                        style={{ maxWidth: '100px' }}
                      />
                    </FormGroup>
                    <div className='text-center'>
                      <CommonButton
                        name='Submit'
                        btnClass={'btnPrimary'}
                        type='submit'
                      />
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </div>
        </ModalBody>
      </Modal>

      {/* preview Modal  */}
      <Modal
        id='preview-modal'
        isOpen={modal}
        toggle={handlePreviewModal}
        className='modelCard'
        centered
        style={{
          maxWidth: '95%',
          width: '100%',
          right: '0',
          bottom: '0',
        }}
      >
        <ModalBody className='p-0'>
          <div className='ModalArea'>
            <Container fluid>
              <Row>
                <Col xs={12}>
                  <div className='modalHeading'>
                    <div className='title'>{elem.business_name}</div>
                    <div className='closeButton'>
                      <img
                        src={closeImg}
                        alt='close'
                        onClick={() => setModal(!modal)}
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12}>
                  <PreviewAppModal
                    userId={userId}
                    showButtons={true}
                    isCreditLimitModal={true}
                    hideComponents={modal}
                  />
                </Col>
              </Row>
            </Container>
          </div>
        </ModalBody>
      </Modal>

      {/* Credit Limit Modal*/}
      <Modal
        isOpen={showCreditLimitModal}
        toggle={() => setShowCreditLimitModal(!showCreditLimitModal)}
        centered
        className='creditLimitModal'
        id='creditLimitModal'
      >
        <ModalBody className='p-0'>
          <div className='ModalArea'>
            <Container>
              <Row>
                <Col xs={12}>
                  <div className='modalHeading'>
                    <div className='title'>SET CREDIT LIMIT</div>
                    <div className='closeButton'>
                      <img
                        src={closeImg}
                        alt='close'
                        onClick={() =>
                          setShowCreditLimitModal(!showCreditLimitModal)
                        }
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12}>
                  <Form onSubmit={handleCreditLimitSubmit}>
                    <FormGroup className='d-flex flex-wrap align-items-center mb-0'>
                      <Label className='pt-2 mr-2 font-weight-bold'>
                        Proposed Credit Limit by NH
                        <span className='required'>*</span>
                      </Label>
                      {/* <Input
            type='text'
            id='creditLimit'
            required
            placeholder='Type Here'
            name='creditLimit'
            readOnly
            value={proposedCreditLimit}
            className='creditlimit-input'
          ></Input> */}
                      <Label
                        style={{
                          backgroundColor: '#F8F9FA',
                          padding: '8px 5px',
                        }}
                      >
                        {proposedCreditLimit || 'N/A'}
                      </Label>
                    </FormGroup>
                    <FormGroup className='d-flex flex-wrap align-items-center'>
                      <Label className='mr-2 font-weight-bold'>
                        Assign New Credit Limit
                        <span className='required'>*</span>
                      </Label>
                      <NumberFormatInput
                        required={true}
                        type='text'
                        thousandSeparator={true}
                        thousandsGroupStyle={'lakh'}
                        name='credit-limit'
                        id='credit-limit'
                        placeholder='Type Here'
                        onChange={(e) => handleCreditLimitChange(e)}
                        value={creditLimit}
                        style={{ width: '100px' }}
                      />
                    </FormGroup>
                    <div className='text-center'>
                      <CommonButton
                        name='Submit'
                        btnClass={'btnPrimary'}
                        type='submit'
                      />
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </div>
        </ModalBody>
      </Modal>

      {/* Risk Measure Tag Modal */}
      <Modal
        isOpen={showRiskMeasureTagModal}
        toggle={() => setShowRiskMeasureTagModal(!showRiskMeasureTagModal)}
        centered
        className='riskMeasureTagModal'
        id='riskMeasureTagModal'
      >
        <ModalBody className='p-0'>
          <div className='ModalArea'>
            <Container>
              <Row>
                <Col xs={12}>
                  <div className='modalHeading'>
                    <div className='title'>SET RISK MEASURE TAG</div>
                    <div className='closeButton'>
                      <img
                        src={closeImg}
                        alt='close'
                        onClick={() =>
                          setShowRiskMeasureTagModal(!showRiskMeasureTagModal)
                        }
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12}>
                  <Form onSubmit={handleRiskMeasureTagSubmit}>
                    <FormGroup className='d-flex flex-wrap align-items-center mb-1'>
                      <Label className='mr-4 font-weight-bold'>
                        Proposed Risk Measure by TM
                        <span className='required'>*</span>
                      </Label>
                      {/* <Input
                        type='text'
                        id='prposedRiskMeasure'
                        required
                        placeholder='Type Here'
                        name='prposedRiskMeasure'
                        value={'A'}
                        readOnly
                        className='riskMeasureTag-input'
                      /> */}
                      <Label>{proposedRIskMeasureTag || 'N/A'}</Label>
                    </FormGroup>
                    <FormGroup className='d-flex flex-wrap align-items-center mb-1'>
                      <Label className='mr-1 font-weight-bold'>
                        Assign New Risk Measure Tag
                        <span className='required'>*</span>
                      </Label>
                      <SingleSelect
                        // disabled={editId}
                        id='rmtagSelect'
                        required={true}
                        name='rmtagSelect'
                        value={
                          showRiskMeasureTag === null ||
                            showRiskMeasureTag === 'undefined'
                            ? ''
                            : showRiskMeasureTag
                        }
                        onChange={(e) => handleRiskMeasureTagChange(e)}
                        options={options}
                        label={'name'}
                        selectedValueKey={'name'}
                      />
                    </FormGroup>
                    <div className='text-center'>
                      <CommonButton
                        name='Submit'
                        btnClass={'btnPrimary'}
                        type='submit'
                      />
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </div>
        </ModalBody>
      </Modal>

      {/* Cash Ratio Modal */}
      <Modal
        isOpen={showCashCreditRatioModal}
        toggle={() => setShowCashCreditRatioModal(!showCashCreditRatioModal)}
        centered
        className='cashCreditModal'
        id='cashCreditModal'
      >
        <ModalBody className='p-0'>
          <div className='ModalArea'>
            <Container>
              <Row>
                <Col xs={12}>
                  <div className='modalHeading'>
                    <div className='title'>SET CASH CREDIT RATIO</div>
                    <div className='closeButton'>
                      <img
                        src={closeImg}
                        alt='close'
                        onClick={() =>
                          setShowCashCreditRatioModal(!showCashCreditRatioModal)
                        }
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12}>
                  <Form onSubmit={handleCashCreditRatioSubmit}>
                    <FormGroup className='d-flex flex-wrap'>
                      <Label className='mr-4 font-weight-bold'>
                        Cash Credit Ratio<span className='required'>*</span>
                      </Label>
                      {/* <div>
                        <div>
                          <div className='cash-block'>
                            <Input
                              type='text'
                              id='credit-ratio'
                              required
                              placeholder='Type Here'
                              name='credit-ratio'
                              value={businessInCash + '%'}
                              className='credit-ratio-input'
                            ></Input>
                            <span className='credit'>Cash</span>
                          </div>
                          <span className='ratio-devider'> / </span>
                          <div className='credit-block'>
                            <Input
                              type='text'
                              id='credit-ratio'
                              required
                              placeholder='Type Here'
                              name='credit-ratio'
                              value={businessInCredit + '%'}
                              className='credit-ratio-input'
                            ></Input>
                            <span className='credit'>Credit</span>
                          </div>
                        </div>
                      </div> */}
                      <Label className='d-flex'>
                        <div style={{ width: '30px' }} className='text-center'>
                          {num[0]}%
                          <div className='blueText font-weight-bold mt-2'>
                            Cash
                          </div>
                        </div>
                        <div style={{ width: '30px' }} className='text-center'>
                          <div className='blueText font-weight-bold'>/</div>
                        </div>
                        <div style={{ width: '30px' }} className='text-center'>
                          {num[1]}%
                          <div className='blueText font-weight-bold mt-2'>
                            Credit
                          </div>
                        </div>
                      </Label>
                    </FormGroup>
                    <FormGroup className='d-flex flex-wrap align-items-center'>
                      <Label for='userName' className='mr-2'>
                        Expected Business in Cash
                        <span className='required'>*</span>
                      </Label>
                      <div className='d-flex align-items-center mb-1'>
                        <UserInput
                          type='text'
                          id='cash'
                          required={true}
                          value={businessInCash}
                          placeholder='Type Here'
                          name='cash'
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={(e) => handleCreditRatioChange(e)}
                          style={{
                            maxWidth: '90px',
                            marginRight: '5px',
                            marginBottom: 0,
                          }}
                        />
                        %
                      </div>
                    </FormGroup>
                    <FormGroup className='d-flex flex-wrap align-items-center'>
                      <Label for='userName' className='mr-2'>
                        Expected Business in Credit
                        <span className='required'>*</span>
                      </Label>
                      <div className='d-flex align-items-center mb-1'>
                        <UserInput
                          type='text'
                          id='roleType'
                          disabled
                          required={true}
                          value={businessInCredit}
                          placeholder='Type Here'
                          name='roleType'
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={(e) => handleCreditRatioChange(e)}
                          style={{
                            maxWidth: '90px',
                            marginRight: '5px',
                            marginBottom: 0,
                          }}
                        />
                        %
                      </div>
                    </FormGroup>
                    <div className='text-center'>
                      <CommonButton
                        name='Submit'
                        btnClass={'btnPrimary'}
                        type='submit'
                      />
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </div>
        </ModalBody>
      </Modal>
      {isLoading && <CustomSpinner />}
    </>
  );
};

export default DealerCodeCard;
